import { useEffect, Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";

const MdOne = lazy(() => import("@/pages/MdOne"));
const Projects = lazy(() => import("@/pages/Projects"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const ProjectDetail = lazy(() => import("@/pages/ProjectDetail"));
const ProjectMap = lazy(() => import("@/pages/ProjectMap"));
const EmiCalculator = lazy(() => import("@/pages/EmiCalculator"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const CanonicalUrl = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    const path = pathname !== "/" ? pathname.replace(/\/+$/, "") : "/";
    link.setAttribute("href", `${window.location.origin}${path}`);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="grain min-h-screen bg-ink text-bone relative">
        <a
          href="#main-content"
          data-testid="skip-to-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[300] focus:bg-ember focus:text-ink focus:px-5 focus:py-3 focus:font-display focus:text-xs focus:uppercase focus:tracking-[0.2em]"
        >
          Skip to content
        </a>
        <div className="grid-lines hidden md:flex" aria-hidden="true">
          <span /><span /><span /><span />
        </div>
        <BrowserRouter>
          <ScrollToTop />
          <CanonicalUrl />
          <Navbar />
          <main id="main-content" className="relative z-10">
            <Suspense fallback={<div className="min-h-[100svh] bg-ink" />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/md-one" element={<MdOne />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:slug" element={<ProjectDetail />} />
                <Route path="/project-map" element={<ProjectMap />} />
                <Route path="/emi-calculator" element={<EmiCalculator />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <WhatsAppFloat />
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
